import { h, Component } from 'preact'
import s from './Modal.css'

interface iProps {
  isOpen: boolean
  onClose: () => void
}

class Modal extends Component<iProps> {
  render () {
    const {
      children,
      isOpen,
      onClose
    } = this.props

    if (!isOpen) {
      return null
    }

    return (
      <div className={s.Modal}>
        <div
          className={s.Modal__overlay}
          onClick={onClose}
        />
        <div className={s.Modal__content}>
          {children}
        </div>
      </div>
    )
  }
}

export default Modal
